import { isAppActive } from '../utils/appActivity';

const viewingPath = /^(?:\/(?:ru|es|fr|ja|ko|pt|tr|zh|de|it|hi))?(?:\/|\/opinion\/\d+|\/user\/[^/]+\/opinion\/\d+|\/news\/\d+\/(?:statistic|reactions))\/?$/;
export const canShowOnPath = path => viewingPath.test(path);

export function isEngagementBlocked(pathname, quietUntil = 0) {
  if (!canShowOnPath(pathname) || !isAppActive() || navigator.onLine === false || Date.now() < quietUntil) return true;
  if (document.activeElement?.matches('input, textarea, [contenteditable="true"], [role="textbox"]')) return true;
  if (document.querySelector('[role="dialog"], [aria-modal="true"], .confirmation-panel, .brand-loader, .app-failure, .load-failure, [aria-busy="true"], .drawing-editor')) return true;
  if (Array.from(document.querySelectorAll('audio,video')).some(player => !player.paused && !player.ended
    && (!player.closest('.news-screen') || player.closest('.current-news')))) return true;
  // External embeds are removed when playback ends by the player coordinator.
  return Boolean(document.querySelector('.external-link__player iframe'));
}

export function isCandidate(value) {
  return Boolean(value && typeof value.id === 'string' && value.id.length <= 100
    && ['publication', 'statistics', 'respondents', 'story_milestone'].includes(value.kind)
    && Number.isSafeInteger(value.storyId) && value.storyId > 0
    && (value.reactionId == null || (Number.isSafeInteger(value.reactionId) && value.reactionId > 0))
    && (value.kind !== 'story_milestone' || (Number.isSafeInteger(value.count) && value.count > 0))
    && Number.isFinite(Date.parse(value.expiresAt)) && Date.parse(value.expiresAt) > Date.now());
}
